
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPumpStaticHorizontal as ObiPumpStaticHorizontalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pump-static-horizontal.js';
 
 
 

 
 export const ObiPumpStaticHorizontal = createComponent({
   react: React,
   tagName: 'obi-pump-static-horizontal',
   elementClass: ObiPumpStaticHorizontalElement,
   events: {
     
   }
  });
 
 